import { AuthLayout, DefaultLayout } from '@/components/layouts'

export const publicRoute = [
  {
    path: '*',
    component: () => import(/* webpackChunkName: "errors-404" */ '@/views/Error/NotFound.vue'),
  },
  {
    path: '/auth',
    component: AuthLayout,
    meta: { title: 'Login' },
    redirect: '/auth/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        meta: { title: 'Login' },
        component: () => import(/* webpackChunkName: "login" */ '@/views/Authentication/Login.vue'),
      },
    ],
  },

  {
    path: '/404',
    name: '404',
    meta: { title: 'Not Found' },
    component: () => import(/* webpackChunkName: "errors-404" */ '@/views/Error/NotFound.vue'),
  },

  {
    path: '/500',
    name: '500',
    meta: { title: 'Server Error' },
    component: () => import(/* webpackChunkName: "errors-500" */ '@/views/Error/Error.vue'),
  },
]

export const protectedRoute = [
  {
    path: '/',
    component: DefaultLayout,
    meta: { title: 'Home', group: 'apps' },
    redirect: '/start',
    children: [
      {
        path: '/start',
        name: 'Start',
        meta: { title: 'Start', group: 'apps' },
        component: () => import(/* webpackChunkName: "start" */ '@/views/Wizard/Start.vue'),
      },

      {
        path: '/confirm',
        name: 'Confirm',
        meta: { title: 'Confirm', group: 'apps' },
        component: () => import(/* webpackChunkName: "confirm" */ '@/views/Wizard/Confirm.vue'),
      },

      {
        path: '/confirm-email',
        name: 'Confirm Email',
        meta: { title: 'Confirm Email', group: 'apps' },
        component: () => import(/* webpackChunkName: "confirm" */ '@/views/Wizard/ConfirmEmail.vue'),
      },

      {
        path: '/paid',
        name: 'Paid',
        meta: { title: 'Paid', group: 'apps' },
        component: () => import(/* webpackChunkName: "paid" */ '@/views/Wizard/Paid.vue'),
      },

      {
        path: '/pay',
        name: 'Pay',
        meta: { title: 'Pay', group: 'apps' },
        component: () => import(/* webpackChunkName: "pay" */ '@/views/Wizard/Pay.vue'),
      },

      {
        path: '/done',
        name: 'Done',
        meta: { title: 'Done', group: 'apps' },
        component: () => import(/* webpackChunkName: "done" */ '@/views/Wizard/Done.vue'),
      },

      {
        path: '/settings',
        name: 'Settings',
        meta: { title: 'Settings', group: 'apps' },
        component: () => import(/* webpackChunkName: "configurations" */ '@/views/Settings/Settings.vue'),
      },

      {
        path: '/403',
        name: 'Forbidden',
        meta: { title: 'Access Denied', hiddenInMenu: true },
        component: () => import(/* webpackChunkName: "error-403" */ '@/views/Error/Deny.vue'),
      },
    ],
  },
]
